import { Component, effect, inject, model, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ICategoriaData } from '@core/interfaces/entidades/categoria.entidad';
import { CategoriaApiService } from '@core/services/api/categoria-api.service';
import { CardCategoria } from '@shared/components/card-categoria/card-categoria';
import { ToastService } from '@shared/services/toast.service';
import { InputBuscador } from '@shared/components/input-buscador/input-buscador';
import { UiButton, UiDialog } from '@shared/components/ui';
import { AppService } from '@shared/services/app.service';
import { CrearCategoria } from '@shared/components/crear-categoria/crear-categoria';
import { SucursalService } from '@shared/services/sucursal.service';

@Component({
  selector: 'app-categoria',
  imports: [CardCategoria, InputBuscador, UiButton, UiDialog, CrearCategoria],
  templateUrl: './categoria.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './categoria.css',
})
export class Categoria implements OnInit {
  constructor() {
    effect(
      () => {
        if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
          this.categoriaApiService.cargar().subscribe({
            next: (data) => {
              this.listaCategorias.set(data);
              this.filtroCategoria.set(data);
            },
            error: (err) => {
              if (err.status == 401) return;
              this.toastService.show(
                'top-right',
                'error',
                'Error',
                err.error.message || 'Error al cargar las categorias',
              );
            },
          });
        }
      },
      { allowSignalWrites: true },
    );
  }
  // data
  busquedaCategoria = model<string>('');
  modal_crear_categoria = model<boolean>(false);
  filtroCategoria = model<ICategoriaData[]>([]);
  listaCategorias = model<ICategoriaData[]>([]);
  // servicios
  private readonly categoriaApiService = inject(CategoriaApiService);
  private readonly toastService = inject(ToastService);
  private readonly appService = inject(AppService);
  private readonly sucursalService = inject(SucursalService);

  // metodos
  onBuscarCategoria() {
    const termino = this.busquedaCategoria().toLowerCase();
    if (termino.trim() === '') {
      this.filtroCategoria.set(this.listaCategorias());
    } else {
      const categoriasFiltradas = this.listaCategorias().filter((categoria) =>
        categoria.nombre.toLowerCase().includes(termino),
      );
      this.filtroCategoria.set(categoriasFiltradas);
    }
  }
  onEliminar(id: number) {
    const nuevasCategorias = this.listaCategorias().filter((cat) => cat.id !== id);
    this.listaCategorias.set(nuevasCategorias);
    this.filtroCategoria.set(nuevasCategorias);
  }
  closeCrearCategoria(data?: ICategoriaData) {
    this.modal_crear_categoria.set(false);
    if (data) {
      const nuevasCategorias = [...this.listaCategorias(), data];
      this.listaCategorias.set(nuevasCategorias);
      this.filtroCategoria.set(nuevasCategorias);
      this.toastService.show(
        'top-right',
        'success',
        'Categoría creada',
        `La categoría ${data.nombre} ha sido creada exitosamente.`,
      );
    }
  }

  ngOnInit(): void {
    this.appService.setPanelHeader({
      title: 'Categorías',
      subtitle: 'Organiza tus categorías',
      showBackButton: true,
      icon: 'bi bi-tags',
    });
  }
}
